<app-map
    #mapRef
  (onMapClose)="closeCard()"
  [mapInitialized]="_mapInitialized"
  [hasErrorLoadingMap]="_errLoadingMap"
/>
